export const UserQuery = 'User'
